

export enum EquipmentTypeEnum {
    LTL = 'ltl',

    FTL = 'ftl',

  BOX = 'box'
}
